var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKidsWatches = function SvgKidsWatches(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.47 371a4.64 4.64 0 0 0-4-4.06 4.08 4.08 0 0 0-3.66 3.82 3.46 3.46 0 0 0 3.53 3.9 4 4 0 0 0 4.13-3.66zM166.47 96V64.58c0-1.8-.81-2.6-2.62-2.6h-45.93c-1.77 0-2.6.64-2.59 2.53v31.2c0 1.5.49 2.51 2.09 2.72 0-4.25 2.48-6.86 6.69-7 2.36-.07 4.73 0 7.09 0 1.77 0 3.58.36 5.3-.43q0-10.33.06-20.68c0-3.07 1.53-4.72 4.29-4.77s4.31 1.74 4.32 4.76V91a17.53 17.53 0 0 1-3.26.51 17.53 17.53 0 0 0 3.26-.51 8 8 0 0 0 2.92.46h9.8a5.9 5.9 0 0 1 5.57 3.28 25.1 25.1 0 0 1 1.26 3.6c1.35-.23 1.75-1.15 1.75-2.34zM144.43 405.81a4 4 0 0 0-3.79-3.93 4 4 0 0 0-3.87 3.8 3.52 3.52 0 0 0 3.8 3.92 3.92 3.92 0 0 0 3.86-3.79zM166.31 303.4a.78.78 0 0 0 .1-.15.78.78 0 0 1-.1.15zM144.45 475.4a4 4 0 0 0-3.91-3.7c-2.42 0-3.8 1.45-3.76 3.93a3.67 3.67 0 0 0 4 3.78 4.15 4.15 0 0 0 3.67-4.01zM144.43 440.65a4.27 4.27 0 0 0-3.84-3.84 3.77 3.77 0 0 0-3.81 4 3.48 3.48 0 0 0 3.77 3.73 4.18 4.18 0 0 0 3.88-3.89z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145 581.11c2.61-1.23 4.35-3.47 5.89-5.82 3.5-5.33 5.64-11.27 7.36-17.35a169.75 169.75 0 0 0 4.07-19.79 190.77 190.77 0 0 0 2.32-28.9q.21-94.29.07-188.59c0-2.15 0-4.31-.06-6.46a56.67 56.67 0 0 1-12.55 4.47 53.18 53.18 0 0 1-13.28 1.25 55.43 55.43 0 0 1-21.68-5.31c0 2-.1 4-.1 6v185.08c0 3.94.57 7.87.42 11.82-.17 4.25.59 8.44 1 12.65a152.65 152.65 0 0 0 4.2 24.56c2.19 8.34 4.68 16.61 10.4 23.37 3.09 3.67 6.66 5.49 11.94 3.02zm-8.21-210.32a4.08 4.08 0 0 1 3.66-3.82 4.64 4.64 0 0 1 4 4.06 4 4 0 0 1-4.17 3.66 3.46 3.46 0 0 1-3.51-3.9zm0 34.89a4 4 0 0 1 3.87-3.8 4 4 0 0 1 3.79 3.93 3.92 3.92 0 0 1-3.86 3.79 3.52 3.52 0 0 1-3.82-3.92zm0 35.09a3.77 3.77 0 0 1 3.81-4 4.27 4.27 0 0 1 3.84 3.84 4.18 4.18 0 0 1-3.88 3.85 3.48 3.48 0 0 1-3.78-3.69zm0 34.86c0-2.48 1.34-3.92 3.76-3.93a4 4 0 0 1 3.91 3.7 4.15 4.15 0 0 1-3.69 4 3.67 3.67 0 0 1-3.99-3.77zM162.17 218.73c.76.37 1.58.62 2.38.93 0-1.85.14-3.7.14-5.55V113.67c0-1.42-.46-2.85 0-4.27a3.64 3.64 0 0 1-.46-1.79v-.65a55.35 55.35 0 0 0-.07-6.44 4.24 4.24 0 0 1 .09-1.44 2 2 0 0 1 .42-.76 25.1 25.1 0 0 0-1.26-3.6 5.9 5.9 0 0 0-5.57-3.28h-9.8a8 8 0 0 1-2.92-.46 17.53 17.53 0 0 1-3.26.51 17.28 17.28 0 0 1-5.36-.49c-1.72.79-3.53.38-5.3.43-2.36.07-4.73 0-7.09 0-4.21.12-6.68 2.73-6.69 7 0 2.89-.09 5.79-.14 8.68a5.27 5.27 0 0 1-.23 2.3v110.08a52.21 52.21 0 0 1 23.52-5.49 49.83 49.83 0 0 1 21.6 4.73z",
    fill: "#f4abe0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.08 318.67a56.67 56.67 0 0 0 12.55-4.47c7.58-4.22 14.16-9.57 19.1-16.8a48.2 48.2 0 0 0 8.19-19.17c-.09-.58.12-.93.72-1 2.46.26 4.16-1 5.54-2.83a45 45 0 0 0 0-14.69 5.54 5.54 0 0 0-4.63-3.05c-1.25 0-1.46-.77-1.7-1.76a52.13 52.13 0 0 0-20.34-30.67c-2.24-1.64-4.65-3.05-7-4.56-.8-.31-1.62-.56-2.38-.93a49.83 49.83 0 0 0-21.6-4.73 52.21 52.21 0 0 0-23.53 5.48c-1.67 1-3.42 1.83-5 2.92-15.78 10.77-24.18 25.59-24.15 44.91 0 15.7 6.09 28.79 17.69 39.3a65 65 0 0 0 11.58 8 55.43 55.43 0 0 0 21.68 5.31 53.18 53.18 0 0 0 13.28-1.26zM95.45 266.6a45 45 0 1 1 71 36.65.78.78 0 0 1-.1.15 4.54 4.54 0 0 1-1 .78c-1.54.95-3.12 1.81-4.72 2.59a45 45 0 0 1-65.18-40.17z",
    fill: "#ef6ba0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.28 107.1c0-2.89.09-5.79.14-8.68-1.6-.21-2.1-1.22-2.09-2.72V64.5c0-1.89.82-2.53 2.59-2.53h45.93c1.81 0 2.62.8 2.62 2.6v31.42c0 1.19-.4 2.11-1.73 2.32a2 2 0 0 0-.42.76 4.24 4.24 0 0 0-.09 1.44 55.35 55.35 0 0 1 .07 6.44v.65a3.64 3.64 0 0 0 .46 1.79c7.62-.18 12.63-4.59 12.76-11.91.21-11.62.17-23.26 0-34.89-.13-6.88-5.17-11.7-12-11.74q-24.7-.13-49.41 0a11.74 11.74 0 0 0-11.75 12c0 11.13.23 22.27-.09 33.39-.23 7.72 5.43 13.39 12.87 13.14a5.27 5.27 0 0 0 .14-2.28z",
    fill: "#fdb73e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.18 274.39c5.29-.72 6.71-2.64 6.48-8.76-.14-3.63-2.32-5.64-6.45-5.93a45 45 0 0 1-.03 14.69z",
    fill: "#6ab4e5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92 278.23a1.33 1.33 0 0 0 .72-1c-.64.07-.81.42-.72 1z",
    fill: "#b0906b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.17 70.29c0-3-1.66-4.8-4.32-4.76s-4.28 1.7-4.29 4.77q-.06 10.35-.06 20.7a17.28 17.28 0 0 0 5.43.51 17.53 17.53 0 0 0 3.26-.51q0-10.37-.02-20.71z",
    fill: "#fdb73e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.58 306.77c1.6-.78 3.18-1.64 4.72-2.59a4.54 4.54 0 0 0 1-.78.78.78 0 0 0 .1-.15 45.13 45.13 0 0 1-5.82 3.52z",
    fill: "#f0e5d6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.41 303.25a44.66 44.66 0 1 0-5.83 3.52 44.89 44.89 0 0 0 5.83-3.52z",
    fill: "#f4abe0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ab4e5",
    d: "M135.77 273.39l28.95-3.25-24.76-2.89-24.72-19.67 20.53 25.81z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.05,
    cy: 302.5,
    r: 3.28,
    fill: "#015e85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.05,
    cy: 230.2,
    r: 3.28,
    fill: "#015e85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.06,
    cy: 268.04,
    r: 3.28,
    fill: "#015e85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.75,
    cy: 266.04,
    r: 3.28,
    fill: "#015e85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.69,
    cy: 285.43,
    r: 3.28,
    fill: "#015e85"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.27,
    cy: 249.22,
    r: 3.28,
    fill: "#015e85"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.17,
    cy: 297.6,
    r: 3.28,
    fill: "#015e85"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.08,
    cy: 236.79,
    r: 3.28,
    fill: "#015e85"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.29,
    cy: 298.35,
    r: 3.28,
    fill: "#015e85"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.57,
    cy: 237.28,
    r: 3.28,
    fill: "#015e85"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.09,
    cy: 285.84,
    r: 3.28,
    fill: "#015e85"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.96,
    cy: 249.08,
    r: 3.28,
    fill: "#015e85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.69 371a4.62 4.62 0 0 0-4-4.06 4.08 4.08 0 0 0-3.66 3.82 3.46 3.46 0 0 0 3.52 3.9 4 4 0 0 0 4.14-3.66zM338.69 96V64.58c0-1.8-.82-2.6-2.62-2.6h-45.93c-1.77 0-2.6.64-2.6 2.53.05 10.4 0 20.8 0 31.2 0 1.5.5 2.51 2.09 2.72 0-4.25 2.49-6.86 6.7-7 2.36-.07 4.73 0 7.09 0 1.76 0 3.58.36 5.29-.43q0-10.33.06-20.68c0-3.07 1.54-4.72 4.3-4.77s4.31 1.74 4.32 4.76V91a17.53 17.53 0 0 1-3.26.51 17.53 17.53 0 0 0 3.26-.51 8 8 0 0 0 2.92.46h9.8a5.9 5.9 0 0 1 5.57 3.28 25.1 25.1 0 0 1 1.26 3.6c1.36-.23 1.75-1.15 1.75-2.34zM316.66 405.81a4 4 0 0 0-3.8-3.93 4 4 0 0 0-3.86 3.8 3.52 3.52 0 0 0 3.8 3.92 3.93 3.93 0 0 0 3.86-3.79zM338.53 303.4a.83.83 0 0 0 .11-.15.83.83 0 0 1-.11.15zM316.68 475.4a4 4 0 0 0-3.92-3.7c-2.42 0-3.79 1.45-3.75 3.93a3.66 3.66 0 0 0 4 3.78 4.15 4.15 0 0 0 3.67-4.01zM316.66 440.65a4.28 4.28 0 0 0-3.84-3.84 3.77 3.77 0 0 0-3.81 4 3.47 3.47 0 0 0 3.76 3.73 4.19 4.19 0 0 0 3.89-3.89z",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M317.21 581.11c2.61-1.23 4.34-3.47 5.89-5.82 3.5-5.33 5.64-11.27 7.35-17.35a167.74 167.74 0 0 0 4.08-19.79 190.77 190.77 0 0 0 2.32-28.9q.21-94.29.07-188.59c0-2.15 0-4.31-.06-6.46a56.67 56.67 0 0 1-12.55 4.47 53.18 53.18 0 0 1-13.31 1.25 55.39 55.39 0 0 1-21.68-5.31c0 2-.1 4-.1 6v185.08c0 3.94.58 7.87.42 11.82-.16 4.25.6 8.44 1 12.65a152.63 152.63 0 0 0 4.19 24.56c2.19 8.34 4.69 16.61 10.41 23.37 3.14 3.67 6.7 5.49 11.97 3.02zM309 370.79a4.08 4.08 0 0 1 3.66-3.82 4.62 4.62 0 0 1 4 4.06 4 4 0 0 1-4.17 3.66 3.46 3.46 0 0 1-3.49-3.9zm0 34.89a4 4 0 0 1 3.86-3.8 4 4 0 0 1 3.8 3.93 3.93 3.93 0 0 1-3.86 3.79 3.52 3.52 0 0 1-3.8-3.92zm0 35.09a3.77 3.77 0 0 1 3.81-4 4.28 4.28 0 0 1 3.84 3.84 4.19 4.19 0 0 1-3.89 3.85 3.47 3.47 0 0 1-3.76-3.69zm0 34.86c0-2.48 1.33-3.92 3.75-3.93a4 4 0 0 1 3.92 3.7 4.15 4.15 0 0 1-3.7 4 3.66 3.66 0 0 1-3.97-3.77zM334.39 218.73c.77.37 1.59.62 2.39.93.05-1.85.14-3.7.14-5.55V113.67c0-1.42-.46-2.85 0-4.27a3.64 3.64 0 0 1-.46-1.79v-.65a55.35 55.35 0 0 0-.07-6.44 4.24 4.24 0 0 1 .09-1.44 2 2 0 0 1 .42-.76 25.1 25.1 0 0 0-1.26-3.6 5.9 5.9 0 0 0-5.57-3.28h-9.8a8 8 0 0 1-2.92-.46 17.68 17.68 0 0 1-8.7 0c-1.71.79-3.53.38-5.29.43-2.36.07-4.73 0-7.09 0-4.21.12-6.68 2.73-6.7 7 0 2.89-.08 5.79-.13 8.68a5.42 5.42 0 0 1-.23 2.3V219.49A52.21 52.21 0 0 1 312.8 214a49.76 49.76 0 0 1 21.59 4.73z",
    fill: "#93b847"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M324.31 318.67a56.67 56.67 0 0 0 12.55-4.47c7.58-4.22 14.16-9.57 19.1-16.8a48 48 0 0 0 8.18-19.17.77.77 0 0 1 .73-1c2.46.26 4.15-1 5.54-2.83a45.26 45.26 0 0 0 0-14.69 5.56 5.56 0 0 0-4.63-3.05c-1.25 0-1.46-.77-1.7-1.76a52.18 52.18 0 0 0-20.34-30.67c-2.24-1.64-4.66-3.05-7-4.56-.8-.31-1.62-.56-2.39-.93A49.76 49.76 0 0 0 312.8 214a52.21 52.21 0 0 0-23.55 5.49c-1.68 1-3.42 1.83-5 2.92-15.8 10.77-24.19 25.62-24.16 44.91 0 15.7 6.09 28.79 17.69 39.3a65 65 0 0 0 11.58 8 55.39 55.39 0 0 0 21.64 5.3 53.18 53.18 0 0 0 13.31-1.25zm-56.63-52.07a45 45 0 1 1 71 36.65.83.83 0 0 1-.11.15 4.27 4.27 0 0 1-1 .78 53.08 53.08 0 0 1-4.73 2.59 44.95 44.95 0 0 1-65.12-40.17z",
    fill: "#16a99e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M289.51 107.1c.05-2.89.09-5.79.13-8.68-1.59-.21-2.09-1.22-2.09-2.72 0-10.4.05-20.8 0-31.2 0-1.89.83-2.53 2.6-2.53h45.93c1.8 0 2.62.8 2.62 2.6v31.42c0 1.19-.39 2.11-1.72 2.32a2 2 0 0 0-.42.76 4.24 4.24 0 0 0-.09 1.44 55.35 55.35 0 0 1 .07 6.44v.65a3.64 3.64 0 0 0 .46 1.79c7.62-.18 12.63-4.59 12.76-11.91.2-11.62.16-23.26-.05-34.89-.12-6.88-5.16-11.7-12-11.74q-24.71-.13-49.41 0a11.74 11.74 0 0 0-11.75 12c0 11.13.23 22.27-.1 33.39-.22 7.72 5.44 13.39 12.88 13.14a5.42 5.42 0 0 0 .18-2.28z",
    fill: "#fdb73e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M370.41 274.39c5.29-.72 6.7-2.64 6.48-8.76-.14-3.63-2.32-5.64-6.45-5.93a45.26 45.26 0 0 1-.03 14.69z",
    fill: "#015e85"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364.14 278.23a1.35 1.35 0 0 0 .73-1 .77.77 0 0 0-.73 1z",
    fill: "#b0906b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M317.4 70.29c0-3-1.66-4.8-4.32-4.76s-4.28 1.7-4.3 4.77q0 10.35-.06 20.68a17.68 17.68 0 0 0 8.7 0c-.01-6.9 0-13.79-.02-20.69z",
    fill: "#fdb73e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.8 306.77a53.08 53.08 0 0 0 4.73-2.59 4.27 4.27 0 0 0 1-.78.83.83 0 0 0 .11-.15 45.24 45.24 0 0 1-5.84 3.52z",
    fill: "#f0e5d6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M338.64 303.25a44.79 44.79 0 1 0-5.84 3.52 44.89 44.89 0 0 0 5.84-3.52z",
    fill: "#93b847"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdb73e",
    d: "M308 273.39l28.95-3.25-24.77-2.89-24.71-19.67L308 273.39z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.27,
    cy: 302.5,
    r: 3.28,
    fill: "#015e85"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.27,
    cy: 230.2,
    r: 3.28,
    fill: "#015e85"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.28,
    cy: 268.04,
    r: 3.28,
    fill: "#015e85"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.98,
    cy: 266.04,
    r: 3.28,
    fill: "#015e85"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.92,
    cy: 285.43,
    r: 3.28,
    fill: "#015e85"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.5,
    cy: 249.22,
    r: 3.28,
    fill: "#015e85"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.4,
    cy: 297.6,
    r: 3.28,
    fill: "#015e85"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.31,
    cy: 236.79,
    r: 3.28,
    fill: "#015e85"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.51,
    cy: 298.35,
    r: 3.28,
    fill: "#015e85"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.8,
    cy: 237.28,
    r: 3.28,
    fill: "#015e85"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.32,
    cy: 285.84,
    r: 3.28,
    fill: "#015e85"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.19,
    cy: 249.08,
    r: 3.28,
    fill: "#015e85"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M483.37 371a4.64 4.64 0 0 0-4-4.06 4.06 4.06 0 0 0-3.65 3.82 3.45 3.45 0 0 0 3.52 3.9 4 4 0 0 0 4.13-3.66zM505.37 96V64.58c0-1.8-.81-2.6-2.62-2.6h-45.93c-1.77 0-2.6.64-2.59 2.53v31.2c0 1.5.49 2.51 2.09 2.72 0-4.25 2.48-6.86 6.69-7 2.36-.07 4.73 0 7.09 0 1.77 0 3.58.36 5.3-.43 0-6.89 0-13.78.06-20.68 0-3.07 1.53-4.72 4.3-4.77s4.3 1.74 4.31 4.76V91a17.4 17.4 0 0 1-3.26.51 17.4 17.4 0 0 0 3.26-.51 8 8 0 0 0 2.92.46h9.8a5.9 5.9 0 0 1 5.57 3.28 25.1 25.1 0 0 1 1.26 3.6c1.38-.23 1.75-1.15 1.75-2.34zM483.34 405.81a4.05 4.05 0 0 0-3.8-3.93 4 4 0 0 0-3.87 3.8 3.53 3.53 0 0 0 3.8 3.92 3.93 3.93 0 0 0 3.87-3.79zM505.21 303.4s.07-.1.11-.15c-.04.05-.07.11-.11.15zM483.35 475.4a4 4 0 0 0-3.91-3.7c-2.42 0-3.8 1.45-3.76 3.93a3.67 3.67 0 0 0 4 3.78 4.15 4.15 0 0 0 3.67-4.01zM483.33 440.65a4.27 4.27 0 0 0-3.84-3.84 3.77 3.77 0 0 0-3.81 4 3.48 3.48 0 0 0 3.77 3.73 4.18 4.18 0 0 0 3.88-3.89z",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M483.88 581.11c2.62-1.23 4.35-3.47 5.89-5.82a61.37 61.37 0 0 0 7.36-17.35 169.75 169.75 0 0 0 4.07-19.79 190.77 190.77 0 0 0 2.32-28.9q.21-94.29.07-188.59v-6.46a56.93 56.93 0 0 1-12.59 4.47 53.18 53.18 0 0 1-13.28 1.25 55.34 55.34 0 0 1-21.72-5.31c0 2-.11 4-.11 6v185.08c0 3.94.57 7.87.42 11.82-.17 4.25.6 8.44 1 12.65a153.77 153.77 0 0 0 4.2 24.56c2.19 8.34 4.68 16.61 10.4 23.37 3.14 3.67 6.71 5.49 11.97 3.02zm-8.2-210.32a4.06 4.06 0 0 1 3.65-3.82 4.64 4.64 0 0 1 4 4.06 4 4 0 0 1-4.17 3.66 3.45 3.45 0 0 1-3.48-3.9zm0 34.89a4 4 0 0 1 3.87-3.8 4.05 4.05 0 0 1 3.8 3.93 3.93 3.93 0 0 1-3.87 3.79 3.53 3.53 0 0 1-3.81-3.92zm0 35.09a3.77 3.77 0 0 1 3.81-4 4.27 4.27 0 0 1 3.84 3.84 4.18 4.18 0 0 1-3.88 3.85 3.48 3.48 0 0 1-3.77-3.69zm0 34.86c0-2.48 1.34-3.92 3.76-3.93a4 4 0 0 1 3.91 3.7 4.15 4.15 0 0 1-3.69 4 3.67 3.67 0 0 1-3.98-3.77zM501.07 218.73c.77.37 1.59.62 2.38.93.05-1.85.14-3.7.14-5.55V113.67c0-1.42-.45-2.85 0-4.27a3.55 3.55 0 0 1-.47-1.79v-.65a53.23 53.23 0 0 0-.07-6.44 4 4 0 0 1 .1-1.44 1.83 1.83 0 0 1 .41-.76 25.1 25.1 0 0 0-1.26-3.6 5.9 5.9 0 0 0-5.57-3.28h-9.8a8 8 0 0 1-2.92-.46 17.64 17.64 0 0 1-8.69 0c-1.72.79-3.53.38-5.3.43-2.36.07-4.73 0-7.09 0-4.21.12-6.68 2.73-6.69 7-.05 2.89-.09 5.79-.14 8.68a5.42 5.42 0 0 1-.22 2.3V219.49a52.21 52.21 0 0 1 23.59-5.49 49.83 49.83 0 0 1 21.6 4.73z",
    fill: "#6ab4e5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M491 318.67a56.93 56.93 0 0 0 12.56-4.47c7.57-4.22 14.15-9.57 19.09-16.8a48.06 48.06 0 0 0 8.19-19.17.77.77 0 0 1 .73-1c2.45.26 4.15-1 5.53-2.83a45 45 0 0 0 0-14.69 5.54 5.54 0 0 0-4.63-3.05c-1.25 0-1.45-.77-1.7-1.76a52.17 52.17 0 0 0-20.33-30.67c-2.25-1.64-4.66-3.05-7-4.56-.79-.31-1.61-.56-2.38-.93a49.83 49.83 0 0 0-21.6-4.73 52.21 52.21 0 0 0-23.55 5.49c-1.67 1-3.41 1.83-5 2.92-15.79 10.77-24.19 25.62-24.16 44.91 0 15.7 6.09 28.79 17.69 39.3a65.06 65.06 0 0 0 11.59 8 55.34 55.34 0 0 0 21.67 5.31 53.18 53.18 0 0 0 13.3-1.27zm-56.65-52.07a45 45 0 1 1 71 36.65c0 .05-.07.11-.11.15a4.54 4.54 0 0 1-1 .78c-1.54.95-3.12 1.81-4.72 2.59a45 45 0 0 1-65.13-40.17z",
    fill: "#015e85"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M456.18 107.1c.05-2.89.09-5.79.14-8.68-1.6-.21-2.1-1.22-2.09-2.72V64.5c0-1.89.82-2.53 2.59-2.53h45.93c1.81 0 2.62.8 2.62 2.6v31.42c0 1.19-.4 2.11-1.73 2.32a1.83 1.83 0 0 0-.41.76 4 4 0 0 0-.1 1.44 53.23 53.23 0 0 1 .07 6.44v.65a3.55 3.55 0 0 0 .47 1.79c7.61-.18 12.62-4.59 12.75-11.91.21-11.62.17-23.26 0-34.89-.13-6.88-5.17-11.7-12-11.74q-24.7-.13-49.41 0a11.74 11.74 0 0 0-11.75 12c0 11.13.24 22.27-.09 33.39-.23 7.72 5.43 13.39 12.88 13.14a5.42 5.42 0 0 0 .13-2.28z",
    fill: "#fdb73e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M537.08 274.39c5.29-.72 6.71-2.64 6.48-8.76-.13-3.63-2.31-5.64-6.45-5.93a45 45 0 0 1-.03 14.69z",
    fill: "#6ab4e5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M530.82 278.23a1.37 1.37 0 0 0 .73-1 .77.77 0 0 0-.73 1z",
    fill: "#b0906b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M484.07 70.29c0-3-1.65-4.8-4.31-4.76s-4.29 1.7-4.3 4.77c0 6.9 0 13.79-.06 20.68a17.64 17.64 0 0 0 8.69 0q0-10.35-.02-20.69z",
    fill: "#fdb73e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M499.48 306.77c1.6-.78 3.18-1.64 4.72-2.59a4.54 4.54 0 0 0 1-.78s.07-.1.11-.15a45.93 45.93 0 0 1-5.83 3.52z",
    fill: "#f0e5d6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M505.32 303.25a44.79 44.79 0 1 0-5.84 3.52 45.93 45.93 0 0 0 5.84-3.52z",
    fill: "#6ab4e5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0592b",
    d: "M474.67 273.39l28.95-3.25-24.76-2.89-24.72-19.67 20.53 25.81z"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 478.95,
    cy: 302.5,
    r: 3.28,
    fill: "#015e85"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 478.95,
    cy: 230.2,
    r: 3.28,
    fill: "#015e85"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.96,
    cy: 268.04,
    r: 3.28,
    fill: "#015e85"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.65,
    cy: 266.04,
    r: 3.28,
    fill: "#015e85"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.59,
    cy: 285.43,
    r: 3.28,
    fill: "#015e85"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.17,
    cy: 249.22,
    r: 3.28,
    fill: "#015e85"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.08,
    cy: 297.6,
    r: 3.28,
    fill: "#015e85"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 460.98,
    cy: 236.79,
    r: 3.28,
    fill: "#015e85"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.19,
    cy: 298.35,
    r: 3.28,
    fill: "#015e85"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.47,
    cy: 237.28,
    r: 3.28,
    fill: "#015e85"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.99,
    cy: 285.84,
    r: 3.28,
    fill: "#015e85"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.86,
    cy: 249.08,
    r: 3.28,
    fill: "#015e85"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKidsWatches, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kids_watches.5d2ae47c.svg";
export { ForwardRef as ReactComponent };